export const records = state => state.records
export const recordTypes = state => state.recordTypes
export const responsibleTypes = state => state.responsibleTypes
export const establishments = state => state.establishments
export const stats = state => state.stats
export const selectedRecord = state => state.selectedRecord
export const loading = state => state.loading
export const error = state => state.error
